<template>
  <table>
      <caption class="subs-caption">This year's {{subs.length}} submissions as at {{asat}}<a v-if="subs.length>0" href="/ssostaff/fracp/fracp-excel.ashx"> 📋&#xFE0E; download excel</a></caption>
      <thead>
          <tr>
              <th @click="setSortKey" :class="{sortme:sortkey=='fullName'}" data-sortkey="fullName">Name</th>
              <th @click="setSortKey" :class="{sortme:sortkey=='dateSubmitted.DateTime'}" data-sortkey="dateSubmitted.DateTime">Submitted</th>
              <!-- <th>Email</th> -->
              <th>Phone</th>
              <th @click="setSortKey" :class="{sortme:sortkey=='comment'}" data-sortkey="comment">Working @</th>
              <th @click="setSortKey" :class="{sortme:sortkey=='intendedYear'}" data-sortkey="intendedYear" title="Year intending to take course">Year</th>
              <th @click="setSortKey" :class="{sortme:sortkey=='lastAttempt'}" data-sortkey="lastAttempt" title="Year of previous attempt if any">Prev</th>
              <th @click="setSortKey" :class="{sortme:sortkey=='online'}" data-sortkey="online" title="Wants to do online">💻&#xFE0E;</th>
              <th @click="setSortKey" :class="{sortme:sortkey=='weekly'}" data-sortkey="weekly" title="Interested in weekly training">🗓&#xFE0E;</th>
          </tr>
      </thead>
      <tbody class="subs-tbody">
          <tr v-for="(r,i) in subs" :key="i">
              <td><a :href="'mailto:'+r.email">{{r.fullName}}</a></td>
              <td>{{shortDateTime(r.dateSubmitted.DateTime)}}</td>
              <!-- <td>{{r.email}}</td> -->
              <td>{{r.contact}}</td>
              <td>{{r.comment}}</td>
              <td>{{r.intendedYear}}</td>
              <td>{{lastAttempt(r)}}</td>
              <td>{{getTic(r.online)}}</td>
              <td>{{getTic(r.weekly)}}</td>
          </tr>
      </tbody>
  </table>
</template>

<script>


export default {
    props:['subs'],
    data: function (){
        return {
            asat: (new Date()).toLocaleDateString('en-NZ',{hour:'numeric', minute:'numeric'}),
            sortkey: ""
        };
    },
    methods: {
        setSortKey: function(event){
            let sk = event.target.dataset.sortkey;
            if (this.sortkey != sk){
                this.sortkey = sk;
                this.subs.sort(function(a,b){ //eslint-disable-line
                let astr = eval("a."+sk)??"zzzzzzzzz";
                let bstr = eval("b."+sk)??"zzzzzzzzz";
                if (typeof(astr)=="number")
                    return bstr-astr;
                return (astr.localeCompare(bstr));
                });
            }
        },
        getTic: function (b){
            return b?'✓':'';
        },
        lastAttempt: function(r){
            let rv = "-";
            if (r.firstAttempt==0)
                rv = r.lastAttempt;
            return rv;
        },
        shortDateTime: function (dt){
            let dateob = new Date(dt);
            return dateob.toLocaleDateString('en-NZ',{day:'numeric',month:'short',hour:'numeric',minute:'numeric'});
        }
    }
}
</script>

<style>
.subs-tbody>tr>td:nth-child(n+5):nth-child(-n+8){
    text-align: center;
}
.subs-tbody>tr>td:nth-child(n+5):nth-child(-n+8):nth-child(odd) {
    background: linear-gradient(90deg, currentColor 1px, transparent 1.5px, transparent calc(100% - 1.5px), currentColor calc(100% - 1px));

}
th.sortme {
    background-color: var(--color-primary);
}
.subs-caption {
    font-size: 1rem;
    font-weight: normal;
    padding: 0.5rem 0;
}
.subs-caption a {
    color: var(--color-primary);
    margin-left: 3rem;
}
</style>